import loader from '@ott/utility-loader';
import { createReducer } from '@reduxjs/toolkit';
import { getOperations } from './actions';
import { OperationState } from './types';

const initialState: OperationState = {
  byId: {},
  startDate: null,
  endDate: null,
  total: 0,
  pageSize: 10,
  pageNumber: 0,
  status: loader.initial(),
};

const operationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getOperations.pending, (state) => {
      state.status = loader.begin();
    })
    .addCase(
      getOperations.fulfilled,
      (
        state,
        {
          payload: {
            operations: { byId, pageNumber, pageSize, total },
            startDate,
            endDate,
          },
        }
      ) => {
        state.byId = {
          ...state.byId,
          ...byId,
        };
        state.pageNumber = pageNumber;
        state.pageSize = pageSize;
        state.total = total;
        state.startDate = startDate;
        state.endDate = endDate;
        state.status = loader.success();
      }
    )
    .addCase(getOperations.rejected, (state) => {
      state.status = loader.error(true);
    });
});

export default operationsReducer;
